import {
  GET_SPACES_REQUEST,
  GET_SPACES_SUCCESS,
  GET_SPACES_FAILURE,
} from "../actions/spacesActions.js";

const INITIAL_STATE = {
  results: [],
  isFetching: false,
  error: false,
};

const spacesListReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_SPACES_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
      };
    case GET_SPACES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        results: action.payload.results,
      };
    case GET_SPACES_FAILURE:
      return {
        ...state,
        isFetching: false,
        results: [],
        error: true,
      };

    default:
      return state;
  }
};

export default spacesListReducer;
